module.exports = __webpack_public_path__ + "static/media/portfolio pic.cd25bed9.jpeg";